<template>
  <v-card elevation="0">
    <v-card-title class="d-flex align-content-end flex-wrap align-items-end">
      <v-row>
        <div class="my-2">
          <v-select
            v-model="query.type"
            label="ประเภทรายการ"
            :items="type"
            item-text="state"
            item-value="type"
            dense
            outlined
          />
        </div>
        <v-spacer />

        <v-text-field
          v-model="query.text"
          append-icon="mdi-magnify"
          autocomplete="off"
          hide-details
          label="ค้นหา"
          @input="query.text = $event"
        />
        <v-spacer />
        <div class="my-2">
          <v-btn
            color="primary"
            @click="fetchData"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            ค้นหา
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            class="ml-2"
            @click="resetFilter"
          >
            ล้าง
          </v-btn>
        </div>
      </v-row>
    </v-card-title>
    <v-data-table
      :footer-props="footer"
      :headers="headers"
      :items.sync="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalItems"
      class="elevation-0"
      item-key="id"
      sortable="false"
    >
      <template #item.created_at="{ item }">
        <span
          class="d-block mt-1 text-monospace"
          style="font-size: 0.8em; min-width: 140px"
        >{{ $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") }}</span>
        <v-chip
          pill
          class="pa-1 mb-1"
          x-small
          color="light"
        >
          {{
            $moment(item.created_at).fromNow()
          }}
        </v-chip>
      </template>
      <template #item.sender="{ item }">
        <span>
          {{ item.user.name }}
        </span>
      </template>
      <template #item.victim="{ item }">
        <span>
          {{ item.related_transaction.user.name }}
        </span>
      </template>
      <template #item.transactionable_type="{ item }">
        <CreditTypeAdmin
          :item_type="item.type"
          :item_transactionable="item.transactionable_type"
          :item_remark="item.remark"
        />
      </template>
      <template #item.amount="{ item }">
        <span
          v-if="item.type.match(/debit/g)"
          class="text-monospace text-right text-success d-block"
        >{{
          item.amount.toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
        }}</span>
        <span
          v-else-if="item.type.match(/credit/g)"
          class="text-monospace text-right text-danger d-block"
        >-{{
          item.amount.toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
        }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import CreditTypeAdmin from './credit-type-admin.vue';

export default {
  name: 'CreditAdminTable',
  components: { CreditTypeAdmin },
  props: {
    url_fetch: { type: String, required: true, default: null },
  },
  data() {
    return {
      options: {},
      loading: true,
      items: [],
      totalItems: 0,
      query: {
        type: 'all',
        text: '',
      },
      headers: [
        {
          text: 'วันที่',
          value: 'created_at',
          align: 'center',
          justify: 'center',
          sortable: false,
          searchable: false,
        },
        {
          text: 'ผู้กระทำ',
          value: 'sender',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'ผู้ถูกกระทำ',
          value: 'victim',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'รายการ',
          value: 'transactionable_type',
          align: 'center',
          justify: 'center',
          sortable: false,
          searchable: false,
        },
        { text: 'จำนวน', value: 'amount', align: 'center' },
      ],
      footer: {
        disableItemsPerPage: true,
        itemsPerPageOptions: [],
        showCurrentPage: true,
      },
      type: [
        { state: 'ทั้งหมด', type: 'all' },
        { state: 'ฝาก-ถอน', type: 'CashTransaction' },
        { state: 'ฝากตรง', type: 'DirectDebitTransaction' },
        { state: 'เล่นเกมส์', type: 'Ticket' },
        { state: 'ถูกรางวัล', type: 'TicketNumber' },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios
        .get(this.url_fetch, {
          params: {
            page: this.options.page,
            sortBy: this.options.sortBy[0],
            sortDirection:
              this.options.sortDesc.length > 0
                ? this.options.sortDesc[0]
                  ? 'ASC'
                  : 'DESC'
                : null,
            pageSize: this.options.itemsPerPage,
            type: this.query.type === 'all' ? 'all' : this.query.type,
            text:
              this.query.text.trim().length === 0
                ? null
                : this.query.text.trim(),
          },
          cancelToken: new axios.CancelToken((c) => {
            this.axiosCanceler = c;
          }),
        })
        .then((response) => {
          Vue.set(this, 'items', response.data.data);
          Vue.set(this, 'totalItems', response.data.total);
          Vue.set(this.options, 'page', response.data.current_page);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.loading = false;
        });
    },
    resetFilter() {
      this.query = {
        text: '',
        type: 'all',
        status: 'all',
      };
      this.fetchData();
    },
  },
};
</script>
